import {gql} from "@irati/utils/gql"

export default gql`
  mutation DeleteTeam($tenantId: String!, $teamId: String!) {
    deleteTeam(tenantId: $tenantId, teamId: $teamId)
  }
`
